import { render, staticRenderFns } from "./SubmitButtonComponent.vue?vue&type=template&id=a3572ec8"
import script from "./SubmitButtonComponent.vue?vue&type=script&lang=js"
export * from "./SubmitButtonComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports